import type { FC, ReactNode } from "react";
import { cn } from "../../utils";

type Props = {
  content?: ReactNode;
  className?: string;
};

const GameRtpListInfo: FC<Props> = ({ content, className }) => (
  <div
    data-slot="game-rtp-list-info"
    className={cn(
      "flex flex-col gap-3 p-4 text-muted-foreground text-sm",
      className,
    )}
  >
    {content}
  </div>
);

export default GameRtpListInfo;
